import { formatVariantLabel } from "./variantLabels";

interface VariantSwatch {
  id: string;
  name: string;
  image: string;
}

interface VariantSwatchSelectorProps {
  variants: VariantSwatch[];
  selectedVariantId: string | null;
  onSelect: (variantId: string) => void;
  readOnly?: boolean;
}

export default function VariantSwatchSelector({
  variants,
  selectedVariantId,
  onSelect,
  readOnly = false,
}: VariantSwatchSelectorProps) {
  const selectedVariant = variants.find((v) => v.id === selectedVariantId);
  const selectedVariantLabel = formatVariantLabel(selectedVariant?.name);

  return (
    <div className="min-w-0 flex-1">
      <p className="font-semibold text-evergreen">
        Color{" "}
        {selectedVariantLabel && (
          <span className="font-normal text-soil">{selectedVariantLabel}</span>
        )}
      </p>
      <div className="mt-2 flex max-h-32 flex-wrap items-center gap-2.5 overflow-y-auto p-1 md:max-h-none">
        {variants.map((v) => {
          const variantLabel = formatVariantLabel(v.name);
          const accessibleLabel = variantLabel ?? "Default product option";

          return (
            <button
              key={v.id}
              onClick={() => !readOnly && onSelect(v.id)}
              className={`h-10 w-10 overflow-hidden rounded-lg ${
                v.id === selectedVariantId
                  ? "ring-2 ring-soil ring-offset-2"
                  : "ring-1 ring-oat"
              } ${readOnly ? "cursor-default" : ""}`}
              aria-label={accessibleLabel}
            >
              <img
                src={v.image}
                alt={accessibleLabel}
                className="h-full w-full object-cover"
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}
